export class ImagePmsDto {
  path: string;
  value: string;
}
